export default ['Elasticsearch', 'PostgreSQL', 'CockroachDB', 'TimescaleDB', 'MongoDB'];
